import { render } from "./index.vue?vue&type=template&id=a40e81a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a40e81a2&lang=less&scoped=true"

import exportComponent from "D:\\huiwu\\wgt_user_web_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40e81a2"]])

export default __exports__